/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface TrackItMeasurementParameterStringDto
 */
export interface TrackItMeasurementParameterStringDto {
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementParameterStringDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof TrackItMeasurementParameterStringDto
     */
    trackItId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementParameterStringDto
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TrackItMeasurementParameterStringDto
     */
    index?: number;
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementParameterStringDto
     */
    value?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementParameterStringDto
     */
    $type?: TrackItMeasurementParameterStringDtoTypeEnum;
}


/**
 * @export
 */
export const TrackItMeasurementParameterStringDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTrackItImportComponentDtoTrackItMeasurementParameterStringDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterStringDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TrackItMeasurementParameterStringDtoTypeEnum = typeof TrackItMeasurementParameterStringDtoTypeEnum[keyof typeof TrackItMeasurementParameterStringDtoTypeEnum];



/**
 * Check if a given object implements the TrackItMeasurementParameterStringDto interface.
 */
export function instanceOfTrackItMeasurementParameterStringDto(value?: unknown): value is TrackItMeasurementParameterStringDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TrackItMeasurementParameterStringDtoTypeEnum)[0];
}

export function TrackItMeasurementParameterStringDtoFromJSON(json: any): TrackItMeasurementParameterStringDto {
    return TrackItMeasurementParameterStringDtoFromJSONTyped(json, false);
}

export function TrackItMeasurementParameterStringDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackItMeasurementParameterStringDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'trackItId': json['trackItId'] == null ? undefined : json['trackItId'],
        'name': json['name'] == null ? undefined : json['name'],
        'index': json['index'] == null ? undefined : json['index'],
        'value': json['value'] == null ? undefined : json['value'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TrackItMeasurementParameterStringDtoToJSON(value?: TrackItMeasurementParameterStringDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'trackItId': value['trackItId'],
        'name': value['name'],
        'index': value['index'],
        'value': value['value'],
        '$type': value['$type'],
    });
}

